import {Injectable} from '@angular/core';

// Classes
import {Product} from '../classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:DynamicPropertiesService'));

@Injectable()
export class DynamicPropertiesService {

    private _productsService = null;

    constructor () {
        // 'Construct dynamic properties service' );
    }
    
    public init (productsService) {
        // 'Initialise dynamic properties service' );
        this._productsService = productsService;
    }

    /**
     * Update dynamic product properties based on values of static properties on the same product.
     * <!> Very high chance of breaking values if not configured properly. Needs more validation.
     * This method and all it's children methods run each time a value on the product is changed.
     * Even if products get destroyed and created identically sometimes.
     * This prevents information syncing issues that could arise and would be very hard to diagnose and debug.
     */
    public updateDynamicProperties ( product: Product ) {
        // '"' + product.code + '" - Parse product dynamic properties' );
                    // // '"' + product.code + '" - Selected options:', product.optionsSelected);

        for (let propertyId in product.dynamicProperties) {
            this._updateDynamicProperty( product, propertyId, product.dynamicProperties[propertyId] );
        }

        debugOff( 'Updated dynamic properties product:', [product] );
    }

    
    private _updateDynamicProperty (product: Product, propertyId: string, dynamicProperty: any) {
        debugOff( 'Update "' + propertyId + '" dynamic property' );
        debugOff( 'Dynamic property:', dynamicProperty );

        // Get dynamic key using the template
        let key = this._getDynamicPropertyKey( product, propertyId, dynamicProperty.keyTemplate );
        debugOff( 'Dynamic property key:', key );

        // Get key value
        let keyValue = this._getKeyValue( key, dynamicProperty.tallies );
        debugOff( 'Key value:', keyValue );

        // Update dynamic property
        let propertyChain = propertyId.split('.');
        this._setPropertyChainValue( product, propertyChain, keyValue );

                    // // '"' + product.code + '" - Selected options:', product.optionsSelected);
        // '"' + product.code + '" - "' + propertyId + '" updated to:', keyValue );
    }

    
    private _getDynamicPropertyKey (product: Product, propertyId: string,  keyTemplate: Array<any>) {
        debugOff( 'Get "' + propertyId + '" dynamic property key' );
        debugOff( 'Key template', keyTemplate );

        let self = this;
        let key = [];

        keyTemplate.forEach( (prodPropertyTemplate, index ) => {
            debugOff( 'Product property template:', prodPropertyTemplate );
            debugOff( 'Index:', index );
            key[index] = this._getProductPropertyValue( product, prodPropertyTemplate );
        });

        return key;
    }

    
    private _getProductPropertyValue (product: Product, prodPropertyTemplate: string) {
        debugOff( 'Get "' + prodPropertyTemplate + '" product property' );

        let propertyChain = prodPropertyTemplate.split('.');
        debugOff( 'Product property chain:', propertyChain );

        let value = this._getPropertyChainValue( product, propertyChain );
        debugOff( 'Property chain value:', propertyChain );

        return value
    }

    
    private _getPropertyChainValue (product: Product, propertyChain: Array<string>) {
        let value = product;

        propertyChain.forEach( propertyId => {
            if( value !== undefined && value !== null ) {
                value = value[propertyId];
            }

            if (value === undefined) {
                console.warn( 'Product "' + product.code + '" property chain, returned undefined value:', propertyChain );
            }

            if (propertyId === 'isSuperGenerator') {
                console.log( 'value', value );
                console.log( 'product', product );
                console.log( 'product._globals', product._globals );
            }
            debugOff( 'Object "' + propertyId + '" property:', value );
        });

        // If property chain is invalid return null
        // Simplifies the logic when assigning dynamic properties
        value === undefined && (value = null);
        debugOff( 'Object dynamic key value:', value );

        return value;
    }

    
    private _setPropertyChainValue (product: Product, propertyChain: Array<string>, value) {
        let object = product,
            maxIndex = propertyChain.length - 1;

        propertyChain.forEach( ( propertyId, index ) => {

            debugOff( propertyId, index, maxIndex );

            if (index !== maxIndex) {

                // Create the object if it doesn't exist
                object[propertyId] === undefined && (object[propertyId] = {});

                // Enter the next scope in the chain
                object = object[propertyId];
            } else {

                // Set the desired value
                object[propertyId] = value;
            }
        });
    }

    /** Needs code cleanup and renaming for clear reading
     */
    private _getKeyValue (key, tallies) {
        debugOff( 'Get key value' );
        debugOff( 'Key:', key );
        debugOff( 'Tallies table:', tallies );

        let value;

        // Each tally set has it's own value to unlock
        tallies.forEach( (row, index) => {

            // Each tally member represents matches different keys for the same value
            row.tally.forEach( tallyMember => {
                let keyMatchesTally = this._checkKeyMatchesTally( key, tallyMember );
                debugOff( 'Table row "' + index + '" matches', keyMatchesTally );

                // Retrieve value if key matches tally
                if (keyMatchesTally === true) {
                    value = row.value
                }
            });

        });

        debugOff( 'Matched value:', value );

        return value;
    }

    
    private _checkKeyMatchesTally (key, tally) {
        debugOff( 'Check key matches tally' );
        debugOff( 'Key:', key );
        debugOff( 'Tally:', tally );

        if (key.length !== tally.length) {  
            console.warn( 'Key:', key );
            console.warn( 'Tally:', tally );
            console.error( 'Key and tally don\'t have same length' ); return; 
        }

        let numOfMatches = 0;

        tally.forEach( (value, index) => {
            if ( tally[index] === key[index] ) {
                debugOff( 'Match found' );
                numOfMatches += 1;
            }
        } );

        let perfectMatch = numOfMatches === key.length;

        debugOff( 'Perfect match found:', perfectMatch );
    
        return perfectMatch;
    
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/dynamic-properties-service.ts